// ------------------------------------
// Constants
// ------------------------------------
import axios from 'axios'
import { protocol, origin } from './addons'

export const GET_IP = 'GET_IP'
export const CHECK_IP = 'CHECK_IP'
// ------------------------------------
// Actions
// ------------------------------------
const getIPAction = (data = undefined) => {
  return {
    type: GET_IP,
    data: data
  }
}

const checkIPAction = (data = undefined) => {
  return {
    type: CHECK_IP,
    data: data
  }
}

export const getIP = () => {
    return (dispatch) => {
      return new Promise((resolve) => {
        return new Promise((resolve) => {
          axios.get(`https://api.ipify.org/?format=json`)
            .then((json) => {
              dispatch(getIPAction(json.data.ip))
              resolve()
            })
            .catch((error) => {
              console.log(error)
              resolve()
            })
        })
      })
    }
  }

  export const checkIP = (ip) => {
    return (dispatch) => {
        return new Promise((resolve) => {
          axios.get(`${protocol}//${origin}/api/vote/check-ip/${ip}`)
            .then((json) => {
              dispatch(checkIPAction(json.data))
              resolve()
            })
            .catch((error) => {
              console.log(error)
              resolve()
            })
        })
    }
  }

export const actions = { getIP }

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GET_IP]: (state, action) => {
    return {
      ...state,
      ip: action.data
    }
  },
  [CHECK_IP]: (state, action) => {
    return {
      ...state,
      isIpUsed: action.data
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  ip: null,
  isIpUsed: false
}

export default function ipReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/ip.js